import { any, element } from 'prop-types';
import  React from 'react';
import _ from 'lodash';
import DropDown from '../../../../components/common/DropDown';
import DateInput from '../../../../components/common/DateBar';
import CheckboxComponent from '../../../../components/common/CheckBox';
import SearchableDropdownComponent from '../../../../components/common/SearchableDropDown';
import ToggleComponent from '../../../../components/common/Toggle';
import { options } from '@fullcalendar/core/preact';
import InputWithLabel from '../../../../components/common/InputwithLabel';
import SelectionItemDropDown from '../../../../components/common/SelectionItemDropDown';
import RadioButtonComponent from '../../../../components/common/Radios';
import AntDateFieldsComponent from '../../../../components/common/AntDatePickerFields';
import SearchableDropdownComponentSmall from '../../../../components/common/SearchableDropDownSmall';
import InputFieldsSmallComponent from '../../../../components/common/InputFieldsSmall';
interface formDataType {
  [key: string]: any;
}
interface objectType {
  [key: string]: any;
}
interface OptionType {
  label: string;
  value: string;
  code: string;
}

type propsType = {
  formData: formDataType;
  handleFormChange: (
    value: string | boolean | OptionType | any,
    key: string,
    field?: formDataType,
    option?: any,
    code?:any,
  ) => void;
  onInputChange?: (value:string, key:string) => any;
  formState: formDataType;
  verified?: any;
 savedItems?:any;
 onClickVerify?:(value:boolean) =>void
 onDropDownClick?: (key: string) => void
};

const HealthFormField = ({
  formData,
  handleFormChange,
  onInputChange,
  formState,
  verified,
 savedItems,
 onClickVerify,
 onDropDownClick = () => {}
}: propsType) => {


  const formKeys = Object.keys(formData) as (keyof formDataType)[];
  return (
    <>
      {formKeys.map((element: any) => {
        const field: formDataType = formData[element];
        const fieldType = field['#type'];
        const title = field['#title'];
        const key: string = field['#webform_key'];
        
        if (!formState[key]) {
          return null;
        }
        
        const isDisabled:boolean=field['#isDisabled'];
        const showPlaceholder: boolean = field['#showPlaceholder'];
        const isMultiDropdown:boolean=field['#multiDropdown'];
        const isGroup = field['#group'];
        const dateMinimum = field['#dateMinimum'];
        const minDate=field['#minDate'];
        const maxDate=field['#maxDate'];
        const isVisible=field['#isVisible'];
        const isRequired =
          field['#required'] && field['#required'] === true ? true : false;
        if (fieldType === 'select') {
          const dataOptions = field['#options'];
            let options;
            const options2: string[] = dataOptions
              ? Object.values(dataOptions)
              : [];
            if(field['#webform_key']=='facility_category') {
              options = field['#options'];
            }
             else if(field['#webform_key']=='facility_type') {
              options = field['#options']
            // }else if(field['#webform_key']=='district') {
            //   options = field['#options']
            }else if(field['#webform_key']=='ownership') {
              options = field['#options']
            }else if(field['#webform_key']=='administrative_body') {
              options = field['#options']
            }else if(field['#webform_key']=='central_govt_dept') {
              options = field['#options']
            }else if(field['#webform_key']=='status') {
              // options = options2.map((option1: any) => ({
              // value: option1.status,
              // label: option1.status,
              // id: option1.satus_id,
            // }));
            options = field['#options']
            }else if(field['#webform_key']=='state') {
              options = options2.map((option1: any) => ({
              value: option1.state_name,
              label: option1.state_name,
              id: option1.state_id,
            }));
            }else if(field['#webform_key']=='district') {
              options = options2.map((option1: any) => ({
              value: `${option1.district_name}-${option1.district_code}`,
              label: `${option1.district_name}-${option1.district_code}`,
              id: option1.district_id,
              code:option1.district_code
            }));
            }else if(field['#webform_key']=='ulb') {
              options = options2.map((option1: any) => ({
              value: `${option1.ulb_name}-${option1.ulb_code}`,
              label: `${option1.ulb_name}-${option1.ulb_code}`,
              id: option1.ulb_id,
              code: option1.ulb_code
            }));
            }else if(field['#webform_key']=='block') {
              options = options2.map((option1: any) => ({
              value: `${option1.block_name}-${option1.block_code}`,
              label: `${option1.block_name}-${option1.block_code}`,
              id: option1.block_id,
              code: option1.block_code
            }));
            }
            else if(field['#webform_key']=='health_block') {
              options = options2.map((option1: any) => ({
              value: `${option1.heal_block_name}-${option1.heal_block_code}`,
              label: `${option1.heal_block_name}-${option1.heal_block_code}`,
              id: option1.health_block_id,
            }));
            }else if(field['#webform_key']=='sub_division') {
              options = options2.map((option1: any) => ({
              value: `${option1.sub_division_name}-${option1.sub_division_code}`,
              label: `${option1.sub_division_name}-${option1.sub_division_code}`,
              id: option1.sub_division_id,
            }));
            }else if(field['#webform_key']=='ward') {
              options = options2.map((option1: any) => ({
                value: `${option1.ward_name}`,
                label: `${option1.ward_name}`,
                id: option1.ward_id,
             }));
            }else if(field['#webform_key']=='parlimentary') {
              options = options2.map((option1: any) => ({
              value: `${option1.pc_name}-${option1.pc_code}`,
              label: `${option1.pc_name}-${option1.pc_code}`,
              id: option1.pc_id,
            }));
            }else if(field['#webform_key']=='lac') {
              options = options2.map((option1: any) => ({
              value: `${option1.ac_name}-${option1.ac_code}`,
              label: `${option1.ac_name}-${option1.ac_code}`,
              id: option1.ac_id,
            }));
            }else if(field['#webform_key']=='sub_district') {
              options = options2.map((option1: any) => ({
              value: `${option1.sub_district_name}-${option1.sub_district_code}`,
              label: `${option1.sub_district_name}-${option1.sub_district_code}`,
              id: option1.sub_district_id,
            }));
            }
            else if(field['#webform_key']=='village') {
              options = field['#options'];
            }
            else if(field['#webform_key']=='gram_panchayat') {
              options = field['#options'];
            }
            else if(field['#webform_key']=='rural_urban') {
              options = field['#options'];
            }

            else{
              options = options2.map((option1: any) => ({
              value: option1,
              label: option1,
            }));

            }
            const value = isMultiDropdown ? formState[key].value && formState[key].value.map((key:string) => ({
              value: key,
              label: key,
            })): formState[key].value? {
              value: formState[key].value,
              label: formState[key].value,
            }:''
            return (
              <div key={key} className={`${key}_wrapper ${isVisible?'showDropdown':'hideDropdown'}`} >
                <SearchableDropdownComponentSmall
                  options={options}
                  onChange={(changedData: any) => handleFormChange(isMultiDropdown ? changedData : changedData?.value, key, changedData?.id, options, changedData?.code)}
                  onInputChange={(inputData:any)=> onInputChange && onInputChange(inputData, key)}                
                  placeHolder={showPlaceholder ? 'Start typing minimum 3 characters to search' : title}
                  multipleSelection={isMultiDropdown ? isMultiDropdown : false}
                  dropDownType={formState[key].isError?'error':'general'}
                  dropLabelName={title}
                  ifRequired={isRequired}
                  dropDownDisable={isDisabled}
                  dropdownsearchable={true}
                  value={value}
                  errorMessage={formState[key].message}
                  isClearable={true}
                
                />
              </div>
            );
          } else if (fieldType === 'date') {
            return (
              <div key={key} className={`${key}_wrapper`}>
                <AntDateFieldsComponent
                  placeholder={title}
                  className={key}
                  onChange={(changedData) => handleFormChange(changedData, key)}
                  labelName={title}
                  isDisabled={isDisabled}
                  type="date"
                  required={isRequired || false}
                  value={formState[key].value}
                  inputType={formState[key].isError?'error':'general'}
                  errorMessage={formState[key].message}
                  disablePastDates={dateMinimum}
                  maxDate={maxDate}
                  minDate={minDate}
                />
              </div>
            );
          }
          else if (fieldType === 'number') {
            return (
              <div key={key} className={`${key}_wrapper`}>
                <InputFieldsSmallComponent
                  placeholder={title}
                  className={key}
                  onChange={(changedData) => handleFormChange(changedData, key)}
                  labelName={title}
                  isDisabled={isDisabled}
                  type="number"
                  required={isRequired || false}
                  value={formState[key].value}
                  inputType={formState[key].isError?'error':'general'}
                  errorMessage={formState[key].message}
                />
              </div>
            );
           } else if (fieldType === 'verify') {
            return (
              <div key={key} className={`${key}_wrapper`}>
                <InputWithLabel
                  labelName={title}
                  inputwithlabelPlaceholder={title}
                  inputlabelPlaceholder={'Verified'}
                  inputlabeltype="text"
                  disabled={isDisabled}
                  required={isRequired}
                  verified={verified[key]}
                  onChange={(changedData) => handleFormChange(changedData, key)}
                  inputlabelvalue={formState[key].value}
                  inputType={formState[key].isError?'error':'general'}
                  errorMessage={formState[key].message}
                  onClickVerify={verified[key]?onClickVerify||function (value: boolean): void {
                    value=true;
                   }:onClickVerify||function (value: boolean): void {
                    value=true;
                   } } 
                   value={formState[key].value}
                   disabledButton={false}
                />
              </div>
            );
          } else if (fieldType === 'radios') {
            return (
              <div key={key} className={`${key}_wrapper`}>
                < RadioButtonComponent
                  radioName={title}
                  radioButtonGroup={isGroup}
                  disabled={isDisabled}
                  onRadioButtonChange={(changedData) => handleFormChange(changedData, key)} />
              </div>
            );
          } else if (fieldType === 'checkbox') {
            return (
              <div key={key} className={`${key}_wrapper`}>
                <CheckboxComponent
                     className=''
                      placeCheckboxBefore={false}
                      isChecked={formState[key].value}
                      checkBoxName={title}
                      disabled={isDisabled===true?true:false||false}
                      onCheckboxChange={(changedData) => handleFormChange(changedData, key)}
                    />
              </div>
            );
          } 
           else if (fieldType === 'toggle') {
            const dataOptions = field['#options'];
            const options: string[] = dataOptions
              ? Object.values(dataOptions)
              : [];
            return (
              <div key={key} className={`${key}_wrapper`}>
                <ToggleComponent
                  onToggleChange={(changedData) =>
                    handleFormChange(changedData, key)
                  }
                  switchName={title}
                  Disabled={isDisabled}
                  switchId=""
                  checked={formState[key].value}
                  switchOnOffNames={options}
                />
              </div>
            );
          } else if (fieldType === 'checkboxes') {
            const checkboxOptions = field['#options'];
            if (!_.isEmpty(checkboxOptions)) {
              return _.keys(checkboxOptions).map((option) => {
                const optionsKey = checkboxOptions[option];
                const removeSpecialChar = option.replace(/[\s?]/g, '_');
                return (
                  <div key={option} className={`${removeSpecialChar}_wrapper`}>
                    <CheckboxComponent
                      className={optionsKey}
                      placeCheckboxBefore={false}
                      isChecked={formState[optionsKey]?.value}
                      checkBoxName={optionsKey}
                      disabled={false}
                      onCheckboxChange={(changedData: boolean) => {
                        handleFormChange(changedData, optionsKey);
                      }}
                    />
                  </div>
                );
              });
            }
            return;
          } else if (fieldType === 'selectionDropdown') {
            return (
              <div key={key} className={`${key}_wrapper ${isVisible?'showDropdown':'hideDropdown'}`}>
                <SelectionItemDropDown
                  dropDownClick={(changedData) =>
                    handleFormChange(changedData, key)}
                  placeHolder={title}
                  multipleSelection={true}
                  dropDownType="general"
                  dropLabelName={title}
                  ifRequired={isRequired}
                  dropDownDisable={true}
                  dropdownsearchable={true}
                  savedItems={savedItems[key]}
  
                />
              </div>
            );
          }
          else if (fieldType === 'webform_section') {
            
            return (
              <>
                <HealthFormField
                  formData={field}
                  handleFormChange={handleFormChange}
                  formState={formState}
                />
                <div className={`hr1-form-${key}`}></div>
              </>
            );
          } else if (fieldType === 'textfield') {
            return (
              <div key={key} className={`${key}_wrapper`}>
                <InputFieldsSmallComponent
                  placeholder={title}
                  className={key}
                  onChange={(changedData) => handleFormChange(changedData, key)}
                  labelName={title}
                  isDisabled={isDisabled}
                  type="text"
                  required={isRequired || false}
                  value={formState[key].value}
                  inputType={formState[key].isError?'error':'general'}
                  errorMessage={formState[key].message}
                />
              </div>
            );
          }





    // return (<>
    //     <div key={key} className={`${key}_wrapper`} >
    //         {key}
    //         </div></>)
})}</>)

  
};

export default HealthFormField;
